import { render, staticRenderFns } from "./trainingModulePageNew2.vue?vue&type=template&id=4b3e5695&scoped=true&"
import script from "./trainingModulePageNew2.vue?vue&type=script&lang=js&"
export * from "./trainingModulePageNew2.vue?vue&type=script&lang=js&"
import style0 from "./trainingModulePageNew2.vue?vue&type=style&index=0&id=4b3e5695&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3e5695",
  null
  
)

export default component.exports